import React from 'react'
import PropTypes from 'prop-types'

import colors from '@settings/styleSettings'
import { Line } from './Line'
import Text from './Text'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    marginBottom: 8,
  },
  verticalLine: {
    width: 4,
    height: 32,
    borderRadius: 8,
  },
  line: {
    marginBottom: 8,
  },
  text: {
    fontSize: 12,
    flex: 2,
    margin: '0 0 0 16px',
    maxWidth: 374,
  },
}

const SugestionLine = ({ text, status, color }) => (
  <>
    <div style={styles.container}>
      <div style={{ ...styles.verticalLine, background: color }} />
      <Text style={{ color: colors.strongGray, ...styles.text }}>{text}</Text>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          flex: 1,
          height: 32,
        }}
      >
        {status(color)}
      </div>
    </div>
    <Line style={styles.line} />
  </>
)

SugestionLine.propTypes = {
  text: PropTypes.string.isRequired,
  status: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
}

export default SugestionLine
